import { Link } from "react-router-dom";
import { House, Warning, ArrowRight } from "@phosphor-icons/react";
import SEO from "../components/SEO";
import CallButton from "../components/CallButton";
import { BUSINESS } from "../data/constants";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page Not Found | GTA Garage Doors"
        description="This page doesn't exist - but we do. Need emergency garage door or locksmith service in the GTA? Call us now, 24/7."
        canonical="/404"
      />
      <section className="min-h-[70vh] bg-[#1B2A4A] text-white flex items-center justify-center px-4">
        <div className="max-w-2xl text-center">
          <div className="inline-flex items-center justify-center h-16 w-16 rounded-sm bg-[#FF6B00]">
            <Warning size={32} weight="fill" />
          </div>
          <div className="mt-6 font-display font-black text-6xl sm:text-7xl lg:text-8xl tracking-tighter text-white">
            404
          </div>
          <h1 className="mt-4 font-display font-black text-2xl sm:text-3xl lg:text-4xl tracking-tight">
            This page doesn't exist — but we do.
          </h1>
          <p className="mt-4 text-white/80 text-base md:text-lg leading-relaxed">
            Need emergency garage door or locksmith service in the GTA? We're
            just one tap away.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <CallButton size="lg" testId="notfound-call-button" />
            <Link
              to="/"
              data-testid="notfound-home-link"
              className="inline-flex items-center justify-center gap-2 rounded-sm border-2 border-white/30 px-6 py-4 font-bold font-display text-white hover:bg-white hover:text-[#1B2A4A] transition-all"
            >
              <House size={18} weight="fill" />
              Back to Home
              <ArrowRight size={16} weight="bold" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
